// Review validation utilities
export const validateReviewInput = (reviewData: {
  rating: number;
  comment?: string;
}) => {
  const errors: string[] = [];

  // Validate rating
  if (!reviewData.rating || reviewData.rating < 1 || reviewData.rating > 5) {
    errors.push("Rating must be between 1 and 5 stars");
  }

  // Validate comment (optional but if provided, check length)
  if (reviewData.comment && reviewData.comment.trim().length > 1000) {
    errors.push("Review comment must be less than 1000 characters");
  }

  // Check for inappropriate content (basic check)
  if (reviewData.comment) {
    const inappropriateWords = ['spam', 'fake', 'scam']; // Basic list, could be expanded
    const lowerComment = reviewData.comment.toLowerCase();
    const hasInappropriateContent = inappropriateWords.some(word =>
      lowerComment.includes(word)
    );

    if (hasInappropriateContent) {
      errors.push("Review contains inappropriate content");
    }
  }

  return errors;
};

export const validateReviewUpdate = (updates: {
  rating?: number;
  comment?: string;
}) => {
  const errors: string[] = [];

  // Validate rating if provided
  if (updates.rating !== undefined && (updates.rating < 1 || updates.rating > 5)) {
    errors.push("Rating must be between 1 and 5 stars");
  }

  // Validate comment if provided
  if (updates.comment !== undefined && updates.comment.length > 1000) {
    errors.push("Review comment must be less than 1000 characters");
  }

  return errors;
};

// Rate limiting check (could be enhanced with actual rate limiting)
export const canSubmitReview = (lastReviewTime?: string) => {
  if (!lastReviewTime) return true;

  const lastReview = new Date(lastReviewTime);
  const now = new Date();
  const hoursSinceLastReview = (now.getTime() - lastReview.getTime()) / (1000 * 60 * 60);

  // Allow one review per business per 24 hours
  return hoursSinceLastReview >= 24;
};